import React from 'react';
import { useParams } from 'react-router';
import _isEmpty from 'lodash/isEmpty';
import Wrapper from '../Wrapper';
import StudentGradebookContainer from './StudentGradebookContainer/StudentGradebookContainer';

const StudentGradebookContainerWrapper = (props) => {
  const { courseId } = useParams();

  let containerProps = props;
  if (_isEmpty(props)) {
    containerProps = {
      courseId,
    };
  }

  return (
    <Wrapper profilerId="StudentGradebook" {...containerProps}>
      <StudentGradebookContainer {...containerProps} />
    </Wrapper>
  );
};

export default StudentGradebookContainerWrapper;
